<template>
    <div>
        <v-row>
            <v-col>
                <textFieldForm 
                    @valueChange="(v) => {values.sensor_id = v.trim(); delete serverErrors.sensor_id}" 
                    :valueInput="values.sensor_id" 
                    :rule="rules.required" 
                    label="Id del checador"
                    :errorMessages="serverErrors.sensor_id"
                ></textFieldForm>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <textFieldForm 
                    @valueChange="(v) => {values.name = v.trim(); delete serverErrors.name}" 
                    :valueInput="values.name" 
                    :rule="rules.required" 
                    label="Nombre"
                    :errorMessages="serverErrors.name"
                ></textFieldForm>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <autocompleteOneForm
                    label="Locación"
                    :valueInput="values.branch_office_id"
                    :rule="rules.required"
                    :items="serverItems.locations"
                    @valueChange="(v) => {values.branch_office_id = v; delete serverErrors[`branch_office_id`]}"
                    :loading="loadingLocations"
                    :errorMessages="serverErrors[`branch_office_id`]"
                ></autocompleteOneForm>
            </v-col>
        </v-row>
               
                
    </div>
</template>

<script>

/* eslint-disable */
export default {
    props: ['values', 'serverErrors'],
   
    data(){
        return {
            loadingLocations: false,
            
            rules: {
				required: [
					v => {
                        if(v == null || v == undefined)
                            return "Campo requerido";
                        try {
                            if(v.trim() == "")
                                return "Campo requerido";
                        } catch (error) {
                            console.log(error);
                        }
                        return true;
                    }
				],
				
				
            },
            serverItems: {
                locations: [],
            },

          
        }
    },
    watch: {
        values: function (vv) {
            //console.log(this.values, vv);
        }
    },
    mounted(){
        this.getLocations()
    },
    methods: {

       
        getLocations(company)
        {
            

            this.loadingLocations = true;
            this.$api.areas.getAreas()
                .then((resp) => {
                    this.serverItems.locations = resp.data.map((item) => {
                        return {value: item.id, text: item.name}
                    });
                })
                .catch((error) => {
                    console.log("error get locations");
                })
                .finally(() => {
                    this.loadingLocations = false;
                })
            ;

        },


    }
}
</script>

<style>

</style>